export default function ecKeyboardService() {
  return { listener, onKey, is };

  ///////////////////////////////////////////////////////////////////////////////////

  /* @deprecated indica si es una tecla "key" incluido para IE11 */
  function is(event, key) {
    return key === getKey(event);
  }

  /*
    Si existe finallyAction siempre se ejecutara y sera el valor del return;
    Si no existe, el return es de la acción si existe.
  */

  function onKey(actions, finallyAction = false) {
    return function handleKey(event) {
      const fn = actions[getKey(event)] || angular.noop;
      if (finallyAction) {
        fn(event);
        return finallyAction(event);
      }
      return fn(event);
    };
  }

  // función que gestiona los eventos de teclados sobre un HTMLElement "elem"

  // EJEMPLO DE USO:
  // const actions = {
  //   'Enter'       : (event) => console.log('Enter clicked', event),
  //   'NumpadEnter' : () => {}, @deprecated NO USAR. Equivale al 'Enter'
  //   'Space'       : () => {},
  //   'ArrowUp'     : () => {},
  //   'ArrowDown'   : () => {},
  //   'ArrowLeft'   : () => {},
  //   'ArrowRight'  : () => {},
  //   'Home'        : () => {},
  //   'End'         : () => {},
  // }
  // const unbindKeyboardListener = keyboardListener(elem, actions)
  // scope.$on('$destroy', ()=> unbindKeyboardListener() )  ¡IMPORTANT!

  function listener(elem, actions) {
    !elem.hasAttribute('tabindex') && elem.setAttribute('tabindex', '0');
    elem.addEventListener('focus', startKeyboard);
    return () => elem.removeEventListener('focus', startKeyboard);

    function startKeyboard(event) {
      elem.addEventListener('keydown', handleKey);
      elem.addEventListener('blur', stopKeyboard);
    }
    function stopKeyboard(event) {
      elem.removeEventListener('keydown', handleKey);
      elem.removeEventListener('blur', stopKeyboard);
    }
    function handleKey(event) {
      return (actions[getKey(event)] || angular.noop)(event);
    }
  }

  /**
   * 03/2022: Eliminamos compatibilidad IE11 y mergeamos las teclas de función del Numpad y Digit
   * @returns key action
   */
  function getKey(event) {
    if (event.code) {
      return event.code.startsWith('Numpad') ? getNumpadKey(event.key) : event.key;
    }
    return event.key;
  }

  // Aprovechamos para normalizar también los 'N' -> 'DigitN'
  function getNumpadKey(key) {
    return key >= 0 && key <= 9 ? `Digit${key}` : key;
  }
}
